export const ACTIVITY_STATUS = {
  PLANNED: 'planned',
  VISITED: 'visited',
  UNVISITED: 'unvisited'
}

export const getActivityStatus = (activity, tripDay, userData) => {
  if (!activity || !userData?.startDate) return ACTIVITY_STATUS.PLANNED
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const actDate = new Date(userData.startDate)
  actDate.setDate(actDate.getDate() + tripDay - 1)
  actDate.setHours(0, 0, 0, 0)
  if (actDate >= today) return ACTIVITY_STATUS.PLANNED
  if (activity.visited === true) return ACTIVITY_STATUS.VISITED
  return ACTIVITY_STATUS.UNVISITED
}

export const getStatusColor = (status, category, getActivityColor) => {
  if (status === ACTIVITY_STATUS.VISITED) return '#4CAF50'
  if (status === ACTIVITY_STATUS.UNVISITED) return '#FF9800'
  return getActivityColor(category)
}
